import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LAYOUT_FEATURE_KEY,
  LayoutState,
  layoutAdapter,
} from './layout.reducer';

// Lookup the 'Layout' feature state managed by NgRx
export const getLayoutState =
  createFeatureSelector<LayoutState>(LAYOUT_FEATURE_KEY);

const { selectAll, selectEntities } = layoutAdapter.getSelectors();

export const getLayoutShowMenuMain = createSelector(
  getLayoutState,
  (state: LayoutState) => state.showMenuMain
);

export const getLayoutShowRightMenu = createSelector(
  getLayoutState,
  (state: LayoutState) => state.showRightMenu
);

export const getLayoutShowProgressbar = createSelector(
  getLayoutState,
  (state: LayoutState) => state.showProgressbar
);

export const getLayoutCustomerParent = createSelector(
  getLayoutState,
  (state: LayoutState) => state.customerParent
);

export const getAllLayout = createSelector(
  getLayoutState,
  (state: LayoutState) => selectAll(state)
);

export const getLayoutEntities = createSelector(
  getLayoutState,
  (state: LayoutState) => selectEntities(state)
);

export const getLayoutLanguage = createSelector(
  getLayoutState,
  (state: LayoutState) => state.language
);
